import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import { VerificationCode } from 'components/auth/VerificationCode/VerificationCode';
import { AuthFlowLayout } from 'components/v2/Layouts/AuthFlowLayout/AuthFlowLayout';
import type { AppDispatch, ReduxState } from 'kb-redux';
import { login } from 'kb-redux/user.redux';
import { showSuccessToast } from 'utilities/notificationUtils';
import { pageUrl } from 'utilities/pageUrl';

interface LocationState {
  email?: string;
  password?: string;
  forgotPassword?: boolean;
}

export const EmailVerificationScreen = () => {
  const location = useLocation();
  const locationState = location?.state as LocationState;
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const isLoggedIn = useSelector<ReduxState>(state => state.patient.isLoggedIn);

  useEffect(() => {
    if (!isLoggedIn) return;
    navigate(pageUrl.dashboard());
  }, [navigate, isLoggedIn]);

  return (
    <AuthFlowLayout
      title="Enter Verification Code"
      renderMainContent={() => {
        return (
          <VerificationCode
            email={locationState?.email}
            onSuccess={() => {
              const email = locationState?.email;
              const password = locationState?.password;

              if (email && password) {
                dispatch(login(email, password));
              } else {
                const forgotPassword = locationState?.forgotPassword;
                if (forgotPassword) {
                  showSuccessToast(
                    'Thank you for verifying your account! You may now reset your password.'
                  );
                  navigate(pageUrl.passwordReset());
                } else {
                  showSuccessToast('Thank you for verifying your account! You may now log in.');
                  navigate(pageUrl.dashboard());
                }
              }
            }}
          />
        );
      }}
    />
  );
};
